module.exports = __webpack_public_path__ + "img/22-r.4593338f.png";